import { DropdownMenu as RMenu } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const Menu = RMenu.Root;
export const MenuTrigger = RMenu.Trigger;
export const MenuGroup = RMenu.Group;
export const MenuRadioGroup = RMenu.RadioGroup;

export function MenuContent({ className, children, ...p }: ComponentProps<typeof RMenu.Content>) {
  return (
    <RMenu.Portal>
      <RMenu.Content
        sideOffset={4}
        align="end"
        {...p}
        className={cn(
          'z-50 min-w-52 rounded-xl border border-border bg-bg p-1.5 text-sm text-fg shadow-pop',
          className,
        )}
      >
        {children}
      </RMenu.Content>
    </RMenu.Portal>
  );
}

const itemCls =
  'flex h-9 touch:h-11 cursor-pointer items-center gap-2.5 rounded-lg px-2.5 outline-none select-none data-[highlighted]:bg-hover data-[disabled]:opacity-40';

export function MenuItem({ className, ...p }: ComponentProps<typeof RMenu.Item>) {
  return <RMenu.Item {...p} className={cn(itemCls, className)} />;
}

export function MenuRadioItem({ className, children, ...p }: ComponentProps<typeof RMenu.RadioItem>) {
  return (
    <RMenu.RadioItem {...p} className={cn(itemCls, className)}>
      <span className="flex w-3 justify-center">
        <RMenu.ItemIndicator className="h-1.5 w-1.5 rounded-full bg-accent" />
      </span>
      {children}
    </RMenu.RadioItem>
  );
}

export function MenuCheckboxItem({ className, children, ...p }: ComponentProps<typeof RMenu.CheckboxItem>) {
  return (
    <RMenu.CheckboxItem {...p} className={cn(itemCls, className)}>
      <span className="flex w-3 justify-center">
        <RMenu.ItemIndicator className="text-accent">✓</RMenu.ItemIndicator>
      </span>
      {children}
    </RMenu.CheckboxItem>
  );
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return <RMenu.Label className="px-2 pt-1.5 pb-1 text-xs font-medium text-faint">{children}</RMenu.Label>;
}

export function MenuSeparator() {
  return <RMenu.Separator className="my-1 h-px bg-border" />;
}
